import ModelBase from "../../../../framework/core/mvvm/model_base";
import { NetClient } from "../../../../framework/net/net_client";
import * as ProtoLogin from "./proto_hall"
import { NetMsgDataMapHall } from "./net_msg_data_map_hall";
import { GameManager } from "../../../../manager/game_manager";
import ModelData, { RoomInfo } from "../../../public/model_data";
import AppData from "../../../public/const/app_data";
import ModuleManager from '../../../../framework/core/module_manager';
import GameUtil from "../../../../utility/game_util";
import EventManager from "../../../../manager/event_manager";
import GameServer from "../gameserver/game_server";
import NetPrompt from "../../../public/module/netprompt/netprompt";
import TimeManager from "../../../../manager/time_manager";
import SceneManager from '../../../../manager/scene_manager';
import SdkStorage from "../../../../sdk/SdkStorage";
import { NotifyData } from "../../../public/notify_data";
import AppController from "../../../../sdk/app_controller";
import Utility from "../../../../utility/utility";
import ShareManager from "../../../../manager/share_manager";
import { TaskHelp } from "../../module/gametask/task_help";

const { ccclass } = cc._decorator;

declare interface ISubscribeData{

    propertyName? : string;
    mapData? : any[];
    ignoreActive?: boolean;

}

export function subscribeMsg(msgData : any[], ignoreActive : boolean = false){
    return function (target: any, propertyName: string){  

        let data : ISubscribeData = {};
        data.ignoreActive = ignoreActive;
        data.mapData = msgData;
        data.propertyName = propertyName;

        target.subscribeMsgList = target.subscribeMsgList ? target.subscribeMsgList : [];
        target.subscribeMsgList.push(data);    
    }
}

//登录重试的次数
let max_reconnect_server_times: number = 3;
// let max_reconnect_server_times_joinroom : number = 10;

enum HallServerCmdState {
    Normal = 1,
    JoinRoom = 2
}

@ccclass
export default class HallServer extends cc.Component {

    public static instance: HallServer;
    hallServerCmdState: HallServerCmdState = HallServerCmdState.Normal
    model: ModelBase;
    netClient: NetClient;
    _reconnectServerTimes: number = 0;
    _onLoginCallback: (protoData: ProtoLogin.Auth.RSP_Login) => void;
    _onLoginComplete: Function;
    _onJoinRoomCallback
    _onCreatRoomCallback
    _isWechatLogin = false
    sourceUserId = 0//邀请者用户id 分享相关
    inviteSourceType = 1//比赛场邀请有礼分享 1其他 2比赛
    wxRoomID = 0//微信邀请进来的roomid
    isLogin = false
    _connectTime = 0
    _connectWaitTime = [0.2, 1, 1, 1, 2, 1]
    ykLogin = true//游客登陆
    _onConnectState: (state: string) => void;
    _url: string;
    _actLoginData: {
        Password?
    };
    _loginSucessReport = false
    onLoad() {
        HallServer.instance = this
        this.model = new ModelBase();
        this.netClient = new NetClient();
        this.netClient.name = "HallServer"
        this.model.init(this.netClient)
        this._init();
    }

    resetConnectTimes() {
        this._reconnectServerTimes = 0
    }

    _init() {
        let self = this;
        self.model.subscibeMsgEvent<ProtoLogin.Auth.RSP_Login>(NetMsgDataMapHall.Account_Login, function (protoData) {
            self.on_login_rsp(protoData);
        }, true);

        self.model.subscibeMsgEvent<ProtoLogin.Auth.RSP_Ping>(NetMsgDataMapHall.Ping, function () {

        }, true);

        self.model.subscibeMsgEvent<ProtoLogin.Auth.RSP_EnterRoom>(NetMsgDataMapHall.Join_Room, function (protoData) {
            self.on_enter_room_rsp(protoData);
        }, true);

        self.model.subscibeMsgEvent<ProtoLogin.Auth.RSP_GoldEnter>(NetMsgDataMapHall.Gold_Enter, function (protoData) {
            self.on_gold_enter_rsp(protoData);
        }, true);

        self.model.subscibeMsgEvent<ProtoLogin.Auth.RSP_CreateRoom>(NetMsgDataMapHall.Creat_Room, function (protoData) {
            self.on_RSP_CreateRoom(protoData);
        }, true);


        self.model.subscibeMsgEvent(NetMsgDataMapHall.Match_Quit, function () {
            EventManager.instance.dispatch("Event_Matching_Exit");
        }, true);


        self.model.subscibeMsgEvent<ProtoLogin.Auth.Notify_MatchRoomInfo>(NetMsgDataMapHall.Notify_MatchRoomInfo, function (protoData) {
            EventManager.instance.dispatch("Event_Matching_Notify_RoomInfo", protoData);
        }, true);

        self.model.subscibeMsgEvent<ProtoLogin.Auth.RSP_GoldQuit>(NetMsgDataMapHall.Gold_Quit, function (protoData) {
            EventManager.instance.dispatch("Event_GoldMatching_Quit", protoData);
        }, true);

        self.model.subscibeMsgEvent<ProtoLogin.Auth.Notify_GoldRoomInfo>(NetMsgDataMapHall.Notify_GoldRoomInfo, function (protoData) {
            EventManager.instance.dispatch("Event_GoldMatching_Notify_RoomInfo", protoData);
        }, true);

    }

    //连接登录
    connectServer(url, callback?: (state: string) => void) {
        this._url = url;
        this._onConnectState = callback
        this.netClient.connect(url);
        //bind是非常必要的，因为从回调回来的this已经改变了已经变了
        this.netClient.onConnectStateEvent = this.onConnectStateEvent.bind(this)
        cc.log("登陆服连接时间：", TimeManager.instance.getServerTime())
        this.unschedule(this.checkConnect)
        this.scheduleOnce(this.checkConnect, 10)
    }

    checkConnect() {
        cc.log("登陆服连接超时，重连！", TimeManager.instance.getServerTime())
        this.unschedule(this.checkConnect)
        HallServer.instance.reconnectServer()
    }

    close() {
        this.unschedule(this.reconnect)
        this.unschedule(this.checkConnect)
        this.netClient.activeClose();
    }

    heartbeat_timeout_reconnect_login_server() {
        this.netClient.disconnect()
    }


    //开始登录，还没成功呢
    accountLogin(userId, password, weiXinCode, callback: (protoData: ProtoLogin.Auth.RSP_Login) => void = null, loginComplete?: Function, LoginType = 7, ) {
        this._isWechatLogin = false
        cc.log("开始登录：", GameManager.loginServer)
        GameManager.reportConversionEvent("login_startLogin", 1)
        let self = this;
        this._onLoginCallback = callback;
        this._onLoginComplete = loginComplete;

        let data: ProtoLogin.Auth.ICMD_Login = {
            ProtoVersion: 1,
            AppName: AppData.appName,
            Password: password,
            Platform: "android",
            UserID: userId,
            ClientVersion: AppData.appVersion,
            EnterGraySrv: false,
            WeiXinCode: weiXinCode,
            ExJsonStr: "",
            LoginType: LoginType,
            Language: AppData.apiLanguage
        }
        self._actLoginData = data;

        this.connectServer(GameManager.loginServer, function (state) {
            if (state == "OPEN") {
                self.model.sendMsg(NetMsgDataMapHall.Account_Login, data);
            }
            cc.log("HallServer连接状态:" + state)
        })
    }

    accountLoginWithData(requestData: any, callback: (protoData: ProtoLogin.Auth.RSP_Login) => void = null) {
        ModelData.instance.wxLoginRequestData = requestData
        cc.log("开始登录：", GameManager.loginServer, requestData)
        this._isWechatLogin = true
        let self = this;
        this._onLoginCallback = callback;
        if (this.netClient.webSocket) {
            cc.log("readyState:", this.netClient.webSocket.readyState)
        }
        this.connectServer(GameManager.loginServer, function (state) {
            cc.log("accountLoginWithData")
            if (state == "OPEN") {
                let data: ProtoLogin.Auth.ICMD_Login = {
                    ProtoVersion: 1,
                    AppName: AppData.appName,
                    ClientVersion: AppData.appVersion,
                    UserID: ModelData.instance.wxLoginRequestData.uerID,
                    Password: ModelData.instance.wxLoginRequestData.password,
                    Language: ModelData.instance.wxLoginRequestData.language,
                    LoginType: ModelData.instance.wxLoginRequestData.loginType
                }
                self.model.sendMsg(NetMsgDataMapHall.Account_Login, data);
            }
            cc.log("连接状态:" + state)
        })
    }


    creatRoom(rule: string, callback?) {
        let self = this;
        this._onCreatRoomCallback = callback
        if (this.netClient.netState) {
            cc.log("====creatRoom1=")
            self.creatRoomMsg(rule)
        }
        else {
            ModelData.instance.loginState = 1
            ModelData.instance.rule = rule
            self.accountLogin(ModelData.instance.roleData.id, ModelData.instance.password, "", function (protoData) {
                if (protoData.ErrorCode == null || protoData.ErrorCode == 0) {
                    self.creatRoomMsg(rule)
                }
            })
        }
    }

    creatRoomMsg(rulejson: string) {
        cc.log("====发送创建房间的包")
        let ruleDic = JSON.parse(rulejson)
        let tmpGameName = ruleDic["gameName"]
        let tmpRoundCount = ruleDic["roundCount"]
        let tmpRule = rulejson
        let tmpHallID = ruleDic["HallID"]
        let data: ProtoLogin.Auth.ICMD_CreateRoom = {
            GameName: tmpGameName,
            IsGoldFieldRoom: false,
            RoundCount: tmpRoundCount,
            Rule: tmpRule,
            HallID: tmpHallID,
            //ExJsonStr: "{\"gps_opened\":false,\"ip\":\"175.13.143.143\",\"latitude\":28.143,\"longitude\":112.143}"
        }
        cc.log(data)
        this.model.sendMsg(NetMsgDataMapHall.Creat_Room, data);
    }

    joinRoom(roomId: number, callback?, exJsonStr?: string, roomIx?: number, goldFieldID?: number, channelID?: number) {
        this.hallServerCmdState = HallServerCmdState.JoinRoom
        ModuleManager.instance.showModuleName("NetPrompt", ModuleManager.instance.moduleHasActive("TableMatchModule") ? { hideAllTheTime: true } : { showImmediately: true })
        let self = this;
        this._onJoinRoomCallback = callback
        cc.warn("====joinRoom,channelId====", channelID, ModelData.instance.roleData.matchingChannelId)
        if (ModelData.instance.roleData.matchingChannelId && ModelData.instance.roleData.matchingChannelId > 1) {
            channelID = ModelData.instance.roleData.matchingChannelId
        }
        if (this.netClient.netState) {
            self.joinRoomMsg(roomId, exJsonStr, roomIx, goldFieldID, channelID)
        }
        else {
            self.accountLogin(ModelData.instance.roleData.id, ModelData.instance.password, "", (protoData: ProtoLogin.Auth.RSP_Login) => {
                if (protoData.ErrorCode == 0) {
                    self.joinRoomMsg(roomId, exJsonStr, roomIx, goldFieldID, channelID)
                }
            })
            ModelData.instance.loginState = 2
            ModelData.instance.roomId = roomId
        }
    }

    joinRoomGoldField(goldFieldID: number, callback?, exJsonStr?: string, RoomIx?: number, channelID?: number) {
        let self = this;
        this._onJoinRoomCallback = callback
        this.hallServerCmdState = HallServerCmdState.JoinRoom
        cc.log("====joinRoomGoldField,channelId====", channelID, ModelData.instance.roleData.matchingChannelId)
        if (ModelData.instance.roleData.matchingChannelId && ModelData.instance.roleData.matchingChannelId > 1) {
            channelID = ModelData.instance.roleData.matchingChannelId
        }
        if (this.netClient.netState) {
            self.joinRoomMsgGoldField(goldFieldID, exJsonStr, RoomIx, channelID)
        }
        else {
            self.accountLogin(ModelData.instance.roleData.id, ModelData.instance.password, "", (protoData: ProtoLogin.Auth.RSP_Login) => {
                if (protoData.ErrorCode == 0) {
                    self.joinRoomMsgGoldField(goldFieldID, exJsonStr, RoomIx, channelID)
                }
            })
            ModelData.instance.loginState = 2
            ModelData.instance.goldFieldID = goldFieldID
        }
    }

    private joinRoomMsg(roomID: number, exJsonStr?: string, roomIx?: number, goldFieldID?: number, channelID?: number) {
        cc.log("加入房间", roomID)
        let data: ProtoLogin.Auth.ICMD_EnterRoom = {
            RoomID: roomID,
            GameName: AppData.gameName,
            ExJsonStr: exJsonStr,
            GoldFieldID: goldFieldID,
            ChannelID: channelID,

        }
        if (roomIx) {
            data.RoomIx = roomIx
        }
        this.model.sendMsg(NetMsgDataMapHall.Join_Room, data);
    }

    private joinRoomMsgGoldField(goldFieldID: number, exJsonStr?: string, roomIx?: number, channelID?: number) {
        cc.log("加入房间GoldFieldID", goldFieldID)
        let data: ProtoLogin.Auth.ICMD_EnterRoom = {
            RoomID: 0,
            GameName: AppData.gameName,
            GoldFieldID: goldFieldID,
            ExJsonStr: exJsonStr,
            ChannelID: channelID ? channelID : 1
        }
        if (roomIx) {
            data.RoomIx = roomIx
        }
        this.model.sendMsg(NetMsgDataMapHall.Join_Room, data);
    }

    onConnectStateEvent(state) {
        this.unschedule(this.checkConnect)
        if (this._onConnectState != null) {
            this._onConnectState(state)
        }
        if (state == 'OPEN') {
        } else if (state == 'CLOSE') {
            this.reconnectServer()
        } else if (state == 'error') {
            this.reconnectServer()
        } else if (state == 'TIMEOUT') {    //超时
            this.reconnectServer()
        } else if (state == 'ActiveClose') {    //主动断开链接
        }
    }

    reconnectServer() {
        let time = 1
        if (this._reconnectServerTimes >= 0 && this._reconnectServerTimes < this._connectWaitTime.length) {
            time = this._connectWaitTime[this._reconnectServerTimes]
        }
        if (this._reconnectServerTimes >= 2) {//断线重连提示
            ModuleManager.instance.showModule(NetPrompt, { showImmediately: true, reconnect: true })
        }

        this.unschedule(this.reconnect)
        this.scheduleOnce(this.reconnect, time)
    }

    private reconnect() {
        let reconnectTime = this.hallServerCmdState == HallServerCmdState.JoinRoom ? max_reconnect_server_times : max_reconnect_server_times
        if (this._reconnectServerTimes > reconnectTime) {
            cc.log("登陆服重连次数用完，提示登陆失败")
            this._reconnectServerTimes = 0
            this.close()
            ModuleManager.instance.hideModule("NetPrompt")

            // SceneManager.gotoAuth()
        } else {
            this._reconnectServerTimes++
            cc.log("发起登陆服重连", this._reconnectServerTimes, max_reconnect_server_times)

            let self = this;
            this.connectServer(GameManager.loginServer, function (state) {
                if (state == "OPEN") {
                    self.model.sendMsg(NetMsgDataMapHall.Account_Login, self._actLoginData);
                }
                cc.log("连接状态:" + state)
            })
        }
    }

    //检查是否心跳超时
    checkHeartBeatTimeOut(timeOutSecs?: number) {
        if (Date.now() > this.netClient.lastReceivePingTime + (timeOutSecs || 15) * 1000) {
            cc.warn("登陆服ping超时，重连！")
            this.reconnectServer()
            return true;
        }
        return false;
    }

    //比赛场准备
    macth_ready(matchId: number, stageId: number, userId: number) {
        let data: ProtoLogin.Auth.ICMD_MatchReady = {
            MatchID: matchId,
            StageID: stageId,
            UserID: userId
        }
        this.model.sendMsg(NetMsgDataMapHall.Match_Ready, data);
    }

    //心跳包
    request_ping() {
        let data: ProtoLogin.Auth.ICMD_Ping = {
            TimeStamp: GameUtil.get_now_timestamp(),
        }
        this.model.sendMsg(NetMsgDataMapHall.Ping, data);
    }

    //进入金币匹配场
    request_goldmatching_enter(goldId, userId, qualifyId?) {
        let data: ProtoLogin.Auth.ICMD_GoldEnter = {
            GoldID: goldId,
            UserID: userId,
        }
        if (qualifyId) {
            //data.CompetitionID = qualifyId
        }
        this.model.sendMsg(NetMsgDataMapHall.Gold_Enter, data);
    }

    //退出金币场
    request_goldmathing_quit(goldId, userId, qualifyId?) {
        let data: ProtoLogin.Auth.ICMD_GoldQuit = {
            GoldID: goldId,
            UserID: userId,
        }
        if (qualifyId) {
            //data.CompetitionID = qualifyId
        }
        this.model.sendMsg(NetMsgDataMapHall.Gold_Quit, data);
    }


    matchingGoldErrorState = false
    start_enter_gold_matching(goldId, qualifyId?) {
        this.matchingGoldErrorState = false
        HallServer.instance.accountLogin(ModelData.instance.roleData.id, ModelData.instance.password, "", () => {
            if (this.matchingGoldErrorState) {
                SceneManager.gotoHallOrClubHall()
            } else {
                HallServer.instance.request_goldmatching_enter(goldId, ModelData.instance.roleData.id, qualifyId)
            }
        })
    }


    setMatchingGoldErrorState() {
        // this._onLoginCallback = null
        this.matchingGoldErrorState = true
    }

    on_login_rsp(protoData: ProtoLogin.Auth.RSP_Login) {
        let self = this;
        ModelData.instance.setQulifyId(null)
        this.unschedule(this.checkConnect)
        if (protoData.ErrorCode == 0) {
            try {
                GameManager.reportConversionEvent("login_loginSuccess", 1)
                if (!(AppData.showHall || AppData.showHall)) {
                    AppController.instance.setFirebaseUserId(protoData.UserID + "")
                    AppData.serverCenter = null
                    if (protoData.version) {
                        let s: any = Utility.jsonParse(protoData.version)
                        if (s) {
                            AppData.serverCenter = s.ver;
                        }
                    }
                    let l = JSON.parse(self._actLoginData.Password)
                    let t = l.passportThridType
                    cc.warn("登陆成功：", self._actLoginData.Password, t)
                    if (t != undefined) {
                        let method = "other"
                        if (t == 3) {
                            method = "line"
                            Utility.reportConversionEvent("login_lineLoginSuc", 1)
                        } else if (t == 2) {
                            method = "facebook"
                            Utility.reportConversionEvent("login_facebookLoginSuc", 1)
                        } else if (t == 4) {
                            method = "token"
                            Utility.reportConversionEvent("login_tokenLoginSuc", 1)
                        }

                        AppController.instance.setFBSDKAppEvents("fb_mobile_complete_registration", { "fb_registration_method": method, "currency": "THB" })
                    }
                }
            } catch (e) {
                cc.error(e)
            }
            ModelData.instance.setRoleData(protoData.UserID, protoData.Password)          
            HallServer.instance.isLogin = true
            if (ModuleManager.instance.moduleHasActive("TableMatchModule")) {
                ModuleManager.instance.showModuleName("NetPrompt", { hideAllTheTime: true })
            } else {
                ModuleManager.instance.showModuleName("NetPrompt", { showImmediately: true })
            }
            this._reconnectServerTimes = 0
            TaskHelp.setLoginTime();
            NotifyData.instance.loginNotifyServer();
            // friend_utils.init();
            if (protoData.LoginArgs) {
                let jsonTable = JSON.parse(protoData.LoginArgs)
                if (jsonTable.userAccount) {
                    let userAccount = JSON.parse(jsonTable.userAccount)
                    ModelData.instance.refreshRoleData(userAccount)
                    if (userAccount.regTime) {
                        ModelData.instance.regTime = userAccount.regTime
                    }
                    if (userAccount.sessionId && userAccount.sessionId != "") {
                        ModelData.instance.roleData.sessionId = jsonTable.SessionID
                        cc.log("取到SessionID：", ModelData.instance.roleData.sessionId)
                    }
                } else {
                    if (jsonTable.SessionID && jsonTable.SessionID != null && jsonTable.SessionID != "") {
                        ModelData.instance.roleData.sessionId = jsonTable.SessionID
                        cc.log("取到SessionID：", ModelData.instance.roleData.sessionId)
                    }
                }
            }

            if (protoData.RoomID != 0) {    //GameName只有在RoomID下才能使用
                if (ModelData.instance.gameDataShow == null) {
                    ModelData.instance.getGameList()
                }
                if (ModelData.instance.shareModuleData == null) {
                    ShareManager.getShareModuleList()
                }
                AppData.gameName = protoData.GameName
                if (protoData.LoginEnv == 'match') {
                    ModelData.instance.tableCommonData.tableType = 2;
                } else if (protoData.LoginEnv == 'new_gold') {
                    let jsonTable = JSON.parse(protoData.LoginArgs);
                    ModelData.instance.tableCommonData.tableType = 1;
                    ModelData.instance.tableCommonData.goldFildId = jsonTable.GoldID;
                    ModelData.instance.setQulifyId(jsonTable.CompetitionID)
                } else {
                    ModelData.instance.tableCommonData.tableType = 0;
                }
                self.joinRoom(protoData.RoomID);
                return;
            }
            if (self._onLoginCallback) {//不能放到后面，可能会报名多个比赛场，可能会自动进入服务器记录的比赛场
                self._onLoginCallback(protoData);
                return;
            }
            if (self._onLoginComplete) {
                self._onLoginComplete();
            }

            let goToHall = function () {
                ModuleManager.instance.showModuleName("NetPrompt", { showImmediately: true })
                SceneManager.gotoHallOrClubHall("HallServerLoginRspToHall")
            }
            if (protoData.LoginEnv == 'match') {
                goToHall()
                return;
            } else if (protoData.LoginEnv == 'new_gold') {
                let jsonTable = JSON.parse(protoData.LoginArgs);
                self.getGoldDataByGoldId(jsonTable.GoldID, function (res) {
                    if (res.code == "SUCCESS") {
                        let data = res.data
                        AppData.gameName = data.gameId;
                        ModelData.instance.setTableCommonData(data)
                        SceneManager.loadingTableModule(null, () => {
                            if (protoData.RoomID == 0) {
                                ModuleManager.instance.showModuleName("TableMatchModule", null, () => {
                                    self.request_goldmatching_enter(jsonTable.GoldID, protoData.UserID, jsonTable.CompetitionID);
                                })
                            }
                            else {
                                self.request_goldmatching_enter(jsonTable.GoldID, protoData.UserID, jsonTable.CompetitionID);
                            }

                        });
                    } else {
                        goToHall()
                    }

                }, function () {
                    goToHall()
                })
                return;
            } else {
                goToHall()
            }
        } else {
            self.close()
            ModuleManager.instance.hideModule("NetPrompt")
            if (!ModuleManager.instance.moduleHasActive("LoginModule")) {
                SceneManager.gotoAuth()
            }
            if (protoData.OMSRet) {
                let omsRetData: any = Utility.jsonParse(protoData.OMSRet)
                if (omsRetData) {
                    ModuleManager.instance.toast500error(omsRetData)
                    if (omsRetData.code == "P00015") {
                        SdkStorage.clearLoginToken(); //token失效
                    }
                    Utility.reportEffect("login_loginError_OMS", omsRetData.code)
                } else {
                    ModuleManager.instance.toast("System Error")
                    Utility.reportEffect("login_loginError_server", protoData.ErrorCode)
                }
            } else {
                ModuleManager.instance.toastKey("server_error_" + protoData.ErrorCode);
                if (protoData.ErrorCode == -1015) {
                    SdkStorage.clearLoginToken(); //token失效
                }
                Utility.reportEffect("login_loginError_server", protoData.ErrorCode)
            }

        }
    }

    on_enter_room_rsp(protoData: ProtoLogin.Auth.RSP_EnterRoom) {
        this.proce_msg_enterRoom(protoData);
    }

    on_gold_enter_rsp(protoData: ProtoLogin.Auth.RSP_GoldEnter) {
        ModelData.instance.setQulifyId(null)
        if (protoData.ErrorCode == 0) {
            if (!ModuleManager.instance.moduleHasActive("TableMatchModule")) {
                ModuleManager.instance.showModule(NetPrompt)
            }

            let data = {
                matchtype: 1,
                goldid: protoData.GoldID,
                gameName: protoData.GameName,
            }
            ModelData.instance.tableCommonData.tableType = 1
            ModelData.instance.tableCommonData.goldFildId = protoData.GoldID
            ModelData.instance.setQulifyId(protoData.CompetitionID)
            SceneManager.gotoMatchingTableModule(data)
        } else {
            if (protoData.ErrorCode == -91) {
                ModuleManager.instance.toast("赛季已结束")
            }
            this.close()
            ModuleManager.instance.toastKey("server_error_" + protoData.ErrorCode);
            ModuleManager.instance.hideModule("NetPrompt")
            // HallServer.instance.reconnect()

            //返回相应
            SceneManager.gotoHallOrClubHall();
        }
    }



    proce_msg_enterRoom(protoData) {
        cc.warn("加入房间：", protoData)
        this.wxRoomID = 0
        EventManager.instance.dispatch("Event_Enter_Room", protoData);
        if (protoData.ErrorCode == 0) {
            this.do_enterRoom(protoData)

        } else {
            ModuleManager.instance.hideModule("NetPrompt")
            ModuleManager.instance.toastKey("server_error_" + protoData.ErrorCode)
            HallServer.instance.close()
            if (this._onJoinRoomCallback) {
                this._onJoinRoomCallback(protoData)
                this._onJoinRoomCallback = null
                return
            }
            // SceneManager.gotoAuth()

            // HallServer.instance.reconnect()
        }
    }

    do_enterRoom(protoData) {
        if (!ModuleManager.instance.moduleHasActive("TableMatchModule")) {
            ModuleManager.instance.showModule(NetPrompt)
        }
        ModelData.instance.initRoomData(protoData)
        let host = protoData.ServerHost
        let port = protoData.wsport
        let rule = JSON.parse(protoData.Rule);
        AppData.gameName = rule.pub_GameName || AppData.gameName
        ModelData.instance.roomId = protoData.RoomID
        GameManager.setGameServerHostPort(host, port)
        HallServer.instance.close()
        GameServer.instance.loginGameServer(GameManager.getGameServerUrl())

        if (protoData.GoldFieldID != 0) {
            ModelData.instance.tableCommonData.goldFildId = protoData.GoldFieldID;
        }
        ModelData.instance.setTableCommonData(rule)
        ModelData.instance.tableCommonData.roomRule = rule;

        NotifyData.instance.changePlayerPos('game')
    }

    on_RSP_CreateRoom(protoData: ProtoLogin.Auth.RSP_CreateRoom) {
        cc.log("创建房间", protoData)
        if (protoData.ErrorCode == 0) {
            if (protoData.RoomID > 0) {
                ModuleManager.instance.showModule(NetPrompt)
                let data: ProtoLogin.Auth.RSP_EnterRoom = new ProtoLogin.Auth.RSP_EnterRoom()
                data.RoomID = protoData.RoomID
                data.ServerHost = protoData.ServerHost
                data.ServerPort = protoData.ServerPort
                data.SeatID = protoData.SeatID
                data.Password = protoData.Password
                ModelData.instance.roomInfo = new RoomInfo()
                ModelData.instance.roomInfo.UserID = ModelData.instance.roleData.id
                ModelData.instance.roomInfo.Password = protoData.Password
                data.Token = protoData.Token
                data.HallID = protoData.HallID
                data.RoomType = protoData.RoomType
                data.wsport = protoData.wsport
                data.Rule = ModelData.instance.rule
                ModelData.instance.tableCommonData.tableType = 0;
                // RunfastData.instance.initJoinRoomData(data)
                ModelData.instance.initRoomData(data)
                HallServer.instance.close()
                GameServer.instance.loginGameServer(GameManager.getGameServerUrl());
            }
        } else {
            ModuleManager.instance.hideModule('NetPrompt')
            HallServer.instance.close()
            ModuleManager.instance.toastKey("server_error_" + protoData.ErrorCode)
        }
    }

    getGoldDataByGoldId(goldId, onSuccess, onFail) {
        let goldData = ModelData.instance.tableCommonData.roomRuleData
        if (goldData && goldData.gameGoldId == goldId) {
            onSuccess && onSuccess(goldData)
            return
        }

        let requestData = {
            baseUrl: "gold/getByGameGoldId?",
            showNetPrompt: true,
            params: {
                gameGoldId: goldId,
            }
        }
        if (requestData.showNetPrompt) {
            ModuleManager.instance.showModuleName("NetPrompt");
        }
        GameUtil.apiHttpGet(requestData, function (data) {
            onSuccess && onSuccess(data)
        }, function (errorData) {
            if (requestData.showNetPrompt) {
                ModuleManager.instance.showModuleName("NetPrompt");
            }
            onFail && onFail(errorData)
        })

    }
}
